import { render, staticRenderFns } from "./ProductImageUpload.vue?vue&type=template&id=bcde5b00&scoped=true"
import script from "./ProductImageUpload.vue?vue&type=script&lang=js"
export * from "./ProductImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductImageUpload.vue?vue&type=style&index=0&id=bcde5b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcde5b00",
  null
  
)

export default component.exports